import React from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import CopyModal from "./CopyModal";
const { Title, Text } = Typography;
export default function SZModal({
  isModalVisible,
  handleCancel,
  handleOk,
  modalType,
  deleteCatalogue,
  updateCatalogueStatus,
  setIsModalVisible,
  id,
  actionLoading,
  details,
  setModalType,
  setId,
  setActionLoading,
  fetchCollections,
}) {
  const deleteTitle = "Are you sure you want to delete this catalogue?";
  const deleteContent =
    "The link will also be deactivated and the buyer can no longer view the catalogue or send queries.";
  const deleteButtonText = "Yes, Delete";

  const deactivateTitle =
    "Are you sure you want to deactivate the catalogue link?";
  const deactivateContent =
    "The link will be deactivated and the buyer can no longer view the catalogue or send queries.";
  const deactivateButtonText = "Yes, Deactivate Link";

  const activateTitle = "Are you sure you want to activate the catalogue link?";
  const activateContent =
    "The link will be activated and visitors can view the products in this catalogue.";
  const activateButtonText = "Yes, Activate";

  const copyCatalogueContent =
    "For creating a new catalogue, you need to rename it or add another buyer's details";

  // confirm
  const confirm = () => {
    if (modalType === "delete") {
      deleteCatalogue(id);
    } else if (modalType === "deactivate") {
      updateCatalogueStatus(id, "inactive");
    } else if (modalType === "activate") {
      updateCatalogueStatus(id, "published");
    }
  };

  const getTitle = () => {
    if (modalType === "delete") return deleteTitle;
    if (modalType === "activate") return activateTitle;
    if (modalType === "deactivate") return deactivateTitle;
  };

  const getContent = () => {
    if (modalType === "delete") return deleteContent;
    if (modalType === "activate") return activateContent;
    if (modalType === "deactivate") return deactivateContent;
  };

  const getButtonText = () => {
    if (modalType === "delete") return deleteButtonText;
    if (modalType === "activate") return activateButtonText;
    if (modalType === "deactivate") return deactivateButtonText;
  };

  return (
    <div>
      {modalType && (
        <Modal
          centered
          footer={null}
          closable={false}
          closeIcon={null}
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          bodyStyle={{ padding: "2em" }}
        >
          {modalType === "copy" ? (
            <CopyModal
              id={id}
              setIsModalVisible={setIsModalVisible}
              details={details}
              isModalVisible={isModalVisible}
              modalType={modalType}
              setModalType={setModalType}
              setId={setId}
              actionLoading={actionLoading}
              setActionLoading={setActionLoading}
              fetchCollections={fetchCollections}
            />
          ) : (
            <>
              <Row justify="center" style={{ textAlign: "center" }}>
                <Col>
                  <Title level={4}>{getTitle()}</Title>
                </Col>
              </Row>

              <Row justify="center" style={{ textAlign: "center" }}>
                <Col>
                  <Text>{getContent()}</Text>
                </Col>
              </Row>
              <Row justify="center" style={{ marginTop: "2em" }}>
                <Col>
                  <Button
                    loading={actionLoading}
                    onClick={() => confirm()}
                    size="large"
                    style={{ width: 180, marginRight: "0.5rem" }}
                  >
                    {getButtonText()}
                  </Button>
                </Col>
                <Col>
                  <Button
                    size="large"
                    style={{
                      border: 0,
                      background: "#363E3D",
                      color: "white",
                      width: 180,
                      marginLeft: "0.5rem",
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </Modal>
      )}
    </div>
  );
}
